import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { ExamDetail } from '~/components/exam-detail'
import { getExam } from '~/functions/exams.functions'
import { examKeys, scopeOf } from '~/lib/query-keys'

export const Route = createFileRoute('/_authed/app/exams/$examId')({
  head: () => ({ meta: [{ title: `${m.exams_title()} – ${m.app_name()}` }] }),
  // A missing exam, and one the caller may not see, both end in the "not found" page
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: examKeys.detail(scopeOf(context.session), params.examId),
      queryFn: () => getExam({ data: { examId: params.examId } }),
    }),
  component: ExamPage,
})

function ExamPage() {
  const { examId } = Route.useParams()
  return <ExamDetail examId={examId} />
}
